import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BiLoaderCircle } from "react-icons/bi";
import {
  List,
  GetTopProductsList,
} from "../../services/seller.service";
import { getuser } from "../../helpers/user.helper";
import formatMoney from "../../helpers/money.helper";
import formatDate from "../../helpers/date.helper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import { GetTopProducts, GetTotalUsers, GetTopResalers } from "../../services/dashboard.admin.service";

export default function ContentAdminDashboard() {
  const monthOptions = [
    { label: "Janeiro", value: 1 },
    { label: "Fevereiro", value: 2 },
    { label: "Março", value: 3 },
    { label: "Abril", value: 4 },
    { label: "Maio", value: 5 },
    { label: "Junho", value: 6 },
    { label: "Julho", value: 7 },
    { label: "Agosto", value: 8 },
    { label: "Setembro", value: 9 },
    { label: "Outubro", value: 10 },
    { label: "Novembro", value: 11 },
    { label: "Dezembro", value: 12 },
  ];

  const yearOptions = [
    { label: "2020", value: 2020 },
    { label: "2021", value: 2021 },
    { label: "2022", value: 2022 },
    { label: "2023", value: 2023 },
  ];

  let date = new Date();

  let navigate = useNavigate();
  const [vendasArray, setVendas] = useState(undefined);
  const [vendasCompletasArray, setVendasCompletas] = useState(0);
  const [ticketMedio, setTicketMedio] = useState(undefined);
  const [topProduct, setTopProduct] = useState(undefined);
  const [TopProducts, setTopProducts] = useState(undefined);
  const [topResalers, setTopResalers] = useState(undefined);
  const [qtdVendas, setQtdVendas] = useState(undefined);
  const [totalUsers, setTotalUsers] = useState(undefined);
  const [selectedMonth, setMonth] = useState(monthOptions[date.getMonth()]);
  const [selectedYear, setYear] = useState({ label: date.getFullYear(), value: date.getFullYear() });
  const [totalTopItens, settotalTopItens] = useState(10);

  const _handleSelectmonth = async (selectChoice) => {
    setMonth(selectChoice);
    console.log('selectChoice', selectChoice)
    await fetDataDashboard();
  };

  const _handleSelectYear = async (selectChoice) => {
    setYear(selectChoice);
    await fetDataDashboard();
  };

  const changeTopProducts = async () => {
    let top = await GetTopProductsList(totalTopItens);
    let topProduct = top?.data[0];
    settotalTopItens(totalTopItens);
    setTopProduct(topProduct);
    setTopProducts(top?.data);
    await fetDataDashboard();
  };

  async function fetDataDashboard() {
    console.log('selectedMonth', selectedMonth)
    let salesPromisse = List(selectedYear.value, selectedMonth.value);
    let topProductsPromisse = GetTopProducts(10, selectedYear.value);
    let totalUsersPromisse = GetTotalUsers();
    let topResalersPromisse = GetTopResalers(selectedYear.value, selectedMonth.value);

    const [saleData, topProductsData, totalUsersData, topResalers] = await Promise.all([
      salesPromisse,
      topProductsPromisse,
      totalUsersPromisse,
      topResalersPromisse
    ]);

    let totalVendas = saleData?.data.length;
    let topProduct = topProductsData?.data[0];
    let arraySlice = saleData?.data.slice(0, 10);

    setVendasCompletas(saleData?.data);
    setQtdVendas(totalVendas);

    if (vendasCompletasArray) {
      let tktMedio = vendasCompletasArray.reduce(getTotal, 0) / totalVendas;
      setTicketMedio(tktMedio);
    }



    setVendas(arraySlice);
    setTotalUsers(totalUsersData?.data);
    setTopProduct(topProduct);
    setTopProducts(topProductsData?.data);
    setTopResalers(topResalers?.data);
  }


  useEffect(() => {
    let user = getuser();

    //Redireciona caso não esteja logado
    if (!user) {
      navigate("/login");
    }

    fetDataDashboard();
  }, [selectedMonth]);

  const showItemClick = (rowData) => {
    navigate(`/venda/${rowData.id}`, { venda: rowData });
  };

  const getTotal = (total, num, qtd) => {
    let preco = parseFloat(num.total);
    return total + Math.round(preco);
  };

  const IconLoader = () => {
    return <BiLoaderCircle className="loader-icon" />;
  };

  const optionButtons = (rowData, column) => {
    return (
      <div>
        <button
          onClick={() => showItemClick(rowData)}
          title="Visualizar item"
          type="button"
          className="btn btn-icon btn-danger btn-sm"
        >
          <i className="fa fa-search"></i>
        </button>
      </div>
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 text-dark">Dashboard Administrador</h1>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-sm-6">
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Selecione um mês"
                  value={selectedMonth}
                  defaultValue={selectedMonth}
                  onChange={_handleSelectmonth}
                  name="month"
                  options={monthOptions}
                />
              </div>
              <div className="col-sm-6">
                <Select
                  className="basic-single"
                  placeholder="Selecione um Ano"
                  classNamePrefix="select"
                  value={selectedYear}
                  defaultValue={selectedYear}
                  onChange={_handleSelectYear}
                  name="year"
                  options={yearOptions}
                />
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 col-6">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{qtdVendas || <IconLoader />}</h3>
                    <p>Qtd. Vendas</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-bag" />
                  </div>
                  {/* <a href="#" className="small-box-footer">Detalhar <i className="fas fa-arrow-circle-right" /></a> */}
                </div>
              </div>
              <div className="col-lg-2 col-6">
                <div className="small-box bg-success">
                  <div className="inner">
                    <h3>
                      {(vendasCompletasArray &&
                        formatMoney(
                          vendasCompletasArray.reduce(getTotal, 0)
                        )) || <IconLoader />}
                    </h3>
                    <p>Total Vendido</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-stats-bars" />
                  </div>
                  {/* <a href="#" className="small-box-footer">Detalhar <i className="fas fa-arrow-circle-right" /></a> */}
                </div>
              </div>
              <div className="col-lg-2 col-6">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>
                      {(vendasCompletasArray &&
                        formatMoney(
                          vendasCompletasArray.reduce(getTotal, 0) / qtdVendas
                        )) || <IconLoader />}
                    </h3>
                    <p>Ticket médio</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-stats-bars" />
                  </div>
                  {/* <a href="#" className="small-box-footer">Detalhar <i className="fas fa-arrow-circle-right" /></a> */}
                </div>
              </div>
              <div className="col-lg-2 col-6">
                <div className="small-box bg-warning">
                  <div className="inner">
                    <h5>
                      {(topProduct && topProduct.desc_produto) || (
                        <IconLoader />
                      )}
                    </h5>
                    <p>Top Produto</p>
                    <h5>{topProduct && `${topProduct.quantidade} Vendas`} </h5>
                  </div>
                  <div className="icon">
                    <i className="ion ion-person-add" />
                  </div>
                  {/* <a href="#" className="small-box-footer">Detalhar <i className="fas fa-arrow-circle-right" /></a> */}
                </div>
              </div>
              <div className="col-lg-2 col-6">
                {/* small box */}
                <div className="small-box bg-danger">
                  <div className="inner">
                    <h3>{totalUsers || <IconLoader />}</h3>
                    <p>Total Usuários</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-pie-graph" />
                  </div>
                  {/* <a href="#" className="small-box-footer">Detalhar <i className="fas fa-arrow-circle-right" /></a> */}
                </div>
              </div>
            </div>
            <div className="row">
              {/* Left col */}
              <section className="col-lg-12 connectedSortable">
                {/* Custom tabs (Charts with tabs)*/}
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">
                      <i className="fas fa-chart-pie mr-1" />
                      Top Vendedores Mês {selectedMonth.value} de {selectedYear.value}
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="tab-content p-0">
                      <DataTable
                        value={topResalers}
                        style={{ marginBottom: 50 }}
                        responsive
                        className="p-datatable-customers"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                        emptyMessage={<IconLoader />}
                      >
                        <Column field="id" header="Código" />

                        <Column field="sellerName" header="Vendedor" />
                        <Column
                          field={(row) => formatMoney(row.total)}
                          header="Valor"
                        />
                        <Column
                          field={(row) => formatDate(row.createAt)}
                          header="Ticket médio"
                        />
                      </DataTable>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div className="row">
              {/* Left col */}
              <section className="col-lg-12 connectedSortable">
                {/* Custom tabs (Charts with tabs)*/}
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">
                      <i className="fas fa-chart-pie mr-1" />
                      Ultimas Vendas
                    </h3>
                    <div className="card-tools">
                      <ul className="nav nav-pills ml-auto">
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            href="/venda/nova"
                            data-toggle="tab"
                          >
                            Nova
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="tab-content p-0">
                      <DataTable
                        value={vendasArray}
                        style={{ marginBottom: 50 }}
                        responsive
                        className="p-datatable-customers"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                        emptyMessage={<IconLoader />}
                      >
                        <Column field="id" header="Código" />
                        <Column
                          field={(row) => formatDate(row.dataImportacao)}
                          header="Data"
                        />
                        <Column
                          field={(row) => row.usuario && row.usuario.nome}
                          header="Usuário"
                        />
                        <Column field="cliente" header="Cliente" />
                        <Column
                          field={(row) => formatMoney(row.total)}
                          header="Valor"
                        />
                        <Column field="qtdItens" header="Qtd. Itens" />
                        <Column
                          key="123"
                          body={optionButtons}
                          bodyStyle={{
                            textAlign: "center",
                            overflow: "hidden",
                          }}
                        />
                      </DataTable>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div className="row">
              {/* Left col */}
              <section className="col-lg-12 connectedSortable">
                <div className="card">
                  <div className="card-header">
                    <h2 className="card-title">
                      <i className="fas fa-chart-pie mr-1" />
                      Top {totalTopItens} Produtos mais vendidos
                    </h2>
                    <div className="card-tools">
                      <div className="row">
                        <div className="col-sm-8">
                          <input
                            type="text"
                            required
                            placeholder="Total de itens "
                            value={totalTopItens}
                            className="form-control"
                            aria-describedby="topItens"
                            name="nome"
                            onChange={(e) => settotalTopItens(e.target.value)}
                            readOnly={false}
                          />
                        </div>
                        <div className="col-sm-4">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={changeTopProducts}
                          >
                            <i className="fa fa-refresh" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="tab-content p-0">
                      <DataTable
                        value={TopProducts}
                        style={{ marginBottom: 50 }}
                        responsive
                        className="p-datatable-customers"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
                        emptyMessage={<IconLoader />}
                      >
                        <Column field="codProduto" header="Código" />
                        <Column field="desc_produto" header="Descrição" />
                        <Column
                          field="quantidade"
                          header="Quantidade de Vendas"
                        />
                      </DataTable>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
